//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthApiGateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authMicrosoft(body: AuthMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/auth-microsoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthMicrosoft(_response);
        });
    }

    protected processAuthMicrosoft(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authLocal(body: AuthLocalRequest | undefined, cancelToken?: CancelToken): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/auth-local";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthLocal(_response);
        });
    }

    protected processAuthLocal(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenants( cancelToken?: CancelToken): Promise<GetUserTenantsResponse> {
        let url_ = this.baseUrl + "/Auth/get-tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: AxiosResponse): Promise<GetUserTenantsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserTenantsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserTenantsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserTenantsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getTenantsRegularToken( cancelToken?: CancelToken): Promise<GetUserTenantsResponse> {
        let url_ = this.baseUrl + "/Auth/get-tenants-regular-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantsRegularToken(_response);
        });
    }

    protected processGetTenantsRegularToken(response: AxiosResponse): Promise<GetUserTenantsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUserTenantsResponse.fromJS(resultData200);
            return Promise.resolve<GetUserTenantsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUserTenantsResponse>(null as any);
    }

    /**
     * @return Success
     */
    appLogo( cancelToken?: CancelToken): Promise<GetAppLogoResponse> {
        let url_ = this.baseUrl + "/Auth/app-logo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAppLogo(_response);
        });
    }

    protected processAppLogo(response: AxiosResponse): Promise<GetAppLogoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAppLogoResponse.fromJS(resultData200);
            return Promise.resolve<GetAppLogoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAppLogoResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserPassword(body: ChangeUserPasswordRequest | undefined, cancelToken?: CancelToken): Promise<ChangeUserPasswordResponse> {
        let url_ = this.baseUrl + "/Auth/change-user-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserPassword(_response);
        });
    }

    protected processChangeUserPassword(response: AxiosResponse): Promise<ChangeUserPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangeUserPasswordResponse.fromJS(resultData200);
            return Promise.resolve<ChangeUserPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangeUserPasswordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    storePluginLoginSessionTokens(body: StorePluginSessionTokensRequest | undefined, cancelToken?: CancelToken): Promise<StorePluginSessionTokensResponse> {
        let url_ = this.baseUrl + "/Auth/store-plugin-login-session-tokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStorePluginLoginSessionTokens(_response);
        });
    }

    protected processStorePluginLoginSessionTokens(response: AxiosResponse): Promise<StorePluginSessionTokensResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StorePluginSessionTokensResponse.fromJS(resultData200);
            return Promise.resolve<StorePluginSessionTokensResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StorePluginSessionTokensResponse>(null as any);
    }

    /**
     * @param sessionId (optional) 
     * @return Success
     */
    getPluginLoginSessionTokens(sessionId: string | undefined, cancelToken?: CancelToken): Promise<GetPluginSessionTokensResponse> {
        let url_ = this.baseUrl + "/Auth/get-plugin-login-session-tokens?";
        if (sessionId === null)
            throw new Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined)
            url_ += "SessionId=" + encodeURIComponent("" + sessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPluginLoginSessionTokens(_response);
        });
    }

    protected processGetPluginLoginSessionTokens(response: AxiosResponse): Promise<GetPluginSessionTokensResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPluginSessionTokensResponse.fromJS(resultData200);
            return Promise.resolve<GetPluginSessionTokensResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPluginSessionTokensResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordSendMail(body: ResetUserPasswordSendMailRequest | undefined, cancelToken?: CancelToken): Promise<ResetUserPasswordSendMailResponse> {
        let url_ = this.baseUrl + "/Auth/reset-password-send-mail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPasswordSendMail(_response);
        });
    }

    protected processResetPasswordSendMail(response: AxiosResponse): Promise<ResetUserPasswordSendMailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetUserPasswordSendMailResponse.fromJS(resultData200);
            return Promise.resolve<ResetUserPasswordSendMailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetUserPasswordSendMailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signupMicrosoft(body: SignupMicrosoftRequest | undefined, cancelToken?: CancelToken): Promise<SignupResponse> {
        let url_ = this.baseUrl + "/Auth/signup-microsoft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignupMicrosoft(_response);
        });
    }

    protected processSignupMicrosoft(response: AxiosResponse): Promise<SignupResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SignupResponse.fromJS(resultData200);
            return Promise.resolve<SignupResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignupResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateToken(body: TokenRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Auth/validate-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateToken(_response);
        });
    }

    protected processValidateToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ToolApiGateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getPortalTools( cancelToken?: CancelToken): Promise<GetToolsResponse> {
        let url_ = this.baseUrl + "/Tool/get-portal-tools";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPortalTools(_response);
        });
    }

    protected processGetPortalTools(response: AxiosResponse): Promise<GetToolsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetToolsResponse.fromJS(resultData200);
            return Promise.resolve<GetToolsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetToolsResponse>(null as any);
    }
}

export class AuthLocalRequest implements IAuthLocalRequest {
    username?: string | undefined;
    password?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IAuthLocalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthLocalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLocalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthLocalRequest {
    username?: string | undefined;
    password?: string | undefined;
    tenantId?: number | undefined;
}

export class AuthMicrosoftRequest implements IAuthMicrosoftRequest {
    token?: string | undefined;
    tenantId?: number | undefined;

    constructor(data?: IAuthMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AuthMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAuthMicrosoftRequest {
    token?: string | undefined;
    tenantId?: number | undefined;
}

export class AuthResponse implements IAuthResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDto[] | undefined;
    tenantId?: number | undefined;
    resetPassword?: boolean | undefined;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.microsoftId = _data["microsoftId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantLoginDto.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.resetPassword = _data["resetPassword"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["microsoftId"] = this.microsoftId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["resetPassword"] = this.resetPassword;
        return data;
    }
}

export interface IAuthResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDto[] | undefined;
    tenantId?: number | undefined;
    resetPassword?: boolean | undefined;
}

export class ChangeUserPasswordRequest implements IChangeUserPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangeUserPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangeUserPasswordRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangeUserPasswordResponse implements IChangeUserPasswordResponse {
    ok?: boolean;

    constructor(data?: IChangeUserPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ChangeUserPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IChangeUserPasswordResponse {
    ok?: boolean;
}

export class GetAppLogoResponse implements IGetAppLogoResponse {
    base64?: string | undefined;

    constructor(data?: IGetAppLogoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64 = _data["base64"];
        }
    }

    static fromJS(data: any): GetAppLogoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAppLogoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        return data;
    }
}

export interface IGetAppLogoResponse {
    base64?: string | undefined;
}

export class GetPluginSessionTokensResponse implements IGetPluginSessionTokensResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expires?: Date;
    validUntil?: Date;

    constructor(data?: IGetPluginSessionTokensResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPluginSessionTokensResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPluginSessionTokensResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetPluginSessionTokensResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expires?: Date;
    validUntil?: Date;
}

export class GetToolsResponse implements IGetToolsResponse {
    tools?: PortalToolDto[] | undefined;

    constructor(data?: IGetToolsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tools"])) {
                this.tools = [] as any;
                for (let item of _data["tools"])
                    this.tools!.push(PortalToolDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetToolsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetToolsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tools)) {
            data["tools"] = [];
            for (let item of this.tools)
                data["tools"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetToolsResponse {
    tools?: PortalToolDto[] | undefined;
}

export class GetUserTenantsResponse implements IGetUserTenantsResponse {
    tenants?: TenantListDto[] | undefined;

    constructor(data?: IGetUserTenantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserTenantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserTenantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserTenantsResponse {
    tenants?: TenantListDto[] | undefined;
}

export class PortalToolDto implements IPortalToolDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;

    constructor(data?: IPortalToolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): PortalToolDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortalToolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["url"] = this.url;
        return data;
    }
}

export interface IPortalToolDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
}

export class ResetUserPasswordSendMailRequest implements IResetUserPasswordSendMailRequest {
    email?: string | undefined;

    constructor(data?: IResetUserPasswordSendMailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ResetUserPasswordSendMailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetUserPasswordSendMailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IResetUserPasswordSendMailRequest {
    email?: string | undefined;
}

export class ResetUserPasswordSendMailResponse implements IResetUserPasswordSendMailResponse {
    ok?: boolean;

    constructor(data?: IResetUserPasswordSendMailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ResetUserPasswordSendMailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetUserPasswordSendMailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IResetUserPasswordSendMailResponse {
    ok?: boolean;
}

export class SignupMicrosoftRequest implements ISignupMicrosoftRequest {
    tenant?: string | undefined;
    token?: string | undefined;

    constructor(data?: ISignupMicrosoftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SignupMicrosoftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignupMicrosoftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["token"] = this.token;
        return data;
    }
}

export interface ISignupMicrosoftRequest {
    tenant?: string | undefined;
    token?: string | undefined;
}

export class SignupResponse implements ISignupResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDto[] | undefined;

    constructor(data?: ISignupResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.microsoftId = _data["microsoftId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.tokenExpiration = _data["tokenExpiration"] ? new Date(_data["tokenExpiration"].toString()) : <any>undefined;
            this.refreshToken = _data["refreshToken"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantLoginDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignupResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignupResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["microsoftId"] = this.microsoftId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["token"] = this.token;
        data["tokenExpiration"] = this.tokenExpiration ? this.tokenExpiration.toISOString() : <any>undefined;
        data["refreshToken"] = this.refreshToken;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISignupResponse {
    id?: number;
    microsoftId?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpiration?: Date;
    refreshToken?: string | undefined;
    tenants?: TenantLoginDto[] | undefined;
}

export class StorePluginSessionTokensRequest implements IStorePluginSessionTokensRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expires?: Date;

    constructor(data?: IStorePluginSessionTokensRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StorePluginSessionTokensRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StorePluginSessionTokensRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        return data;
    }
}

export interface IStorePluginSessionTokensRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expires?: Date;
}

export class StorePluginSessionTokensResponse implements IStorePluginSessionTokensResponse {
    sessionId?: string | undefined;

    constructor(data?: IStorePluginSessionTokensResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data["sessionId"];
        }
    }

    static fromJS(data: any): StorePluginSessionTokensResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StorePluginSessionTokensResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionId"] = this.sessionId;
        return data;
    }
}

export interface IStorePluginSessionTokensResponse {
    sessionId?: string | undefined;
}

export class TenantListDto implements ITenantListDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantListDto {
    id?: number;
    name?: string | undefined;
}

export class TenantLoginDto implements ITenantLoginDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: ITenantLoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITenantLoginDto {
    id?: number;
    name?: string | undefined;
}

export class TokenRequest implements ITokenRequest {
    token?: string | undefined;

    constructor(data?: ITokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): TokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

export interface ITokenRequest {
    token?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}